import React from 'react';
import storage from 'Helpers/storage';

export const AUTO_COLLAPSE_OLD_PROMPTS_STORAGE_KEY = 'panther.ai.autoCollapseOldPrompts';

const readStored = (): boolean => {
  const stored = storage.local.read<boolean | null>(AUTO_COLLAPSE_OLD_PROMPTS_STORAGE_KEY);
  return stored === null ? true : stored;
};

export function useAutoCollapsePrompts(): [boolean, (value: boolean) => void] {
  const [value, setValue] = React.useState<boolean>(readStored);
  const set = React.useCallback((next: boolean) => {
    setValue(next);
    storage.local.write(AUTO_COLLAPSE_OLD_PROMPTS_STORAGE_KEY, next);
  }, []);
  return [value, set];
}
